export enum PackagingInstructionEnum {
  REGULATED = "regulated",
  LIMITED = "limited",
}
